import React from 'react';
import { Result } from 'antd';
import { QuestionCircleOutlined } from '@ant-design/icons';

export default function NotFound() {
  return (
    <Result icon={<QuestionCircleOutlined />} title="404" subTitle="頁面不存在，請確認網址無誤！" />
  );
}
